// import { primitive } from "@primeuix/themes/aura/base";

const theme = {
    primitive: {
        gray: {
            0: '#ffffff',
            50: '#f5f6f8',
            100: '#eceff3',
            200: '#cad4dd',
            300: '#d6dae0',
            400: '#c7ccd3',
            500: '#9FACB8',
            600: '#6f767c',
            700: '#495057',
            800: '#30363c',
            900: '#1e2328'
        },
        blue: {
            0: '#ffffff',
            50: '#E3F2FD',
            100: '#BBDEFB',
            200: '#90CAF9',
            300: '#64B5F6',
            400: '#2196F3',
            500: '#1E88E5',
            600: '#1976D2',
            700: '#1565C0',
            800: '#0D47A1',
            900: '#082A6D'
        },
        green: {
            50: '#e9ffdbff',
            100: '#aeee83',
            200: '#9fe870',
            300: '#98ca76',
            400: '#8ab36f',
            500: '#548B31',
            600: '#5e7e4a',
            700: '#4E6F3A',
            800: '#39512b',
            900: '#223218'
        },
        orange: {
            50: '#fff8f2',
            100: '#fde0c2',
            200: '#fbc791',
            300: '#f9ae61',
            400: '#f79530',
            500: '#f57c00',
            600: '#d06900',
            700: '#ac5700',
            800: '#874400',
            900: '#623200',
        },
        yellow: {
            50: '#fffcf5',
            100: '#fef0cd',
            200: '#fde4a5',
            300: '#fdd87d',
            400: '#fccc55',
            500: '#fbc02d',
            600: '#d5a326',
            700: '#b08620',
            800: '#8a6a19',
            900: '#644d12',
        },
        zinc: {
            0: '#ffffff',
            50: '#fafafa',
            100: '#f4f4f5',
            200: '#e4e4e7',
            300: '#d4d4d8',
            400: '#a1a1aa',
            500: '#71717a',
            600: '#52525b',
            700: '#3f3f46',
            800: '#1c1c1c',
            900: '#111111',
            950: '#000000'
        },
        red: {
            0: '#ffffff',
            50: '#fef2f2',
            100: '#fee2e2',
            200: '#fecaca',
            300: '#fca5a5',
            400: '#f87171',
            500: '#ef4444',
            600: '#dc2626',
            700: '#b91c1c',
            800: '#991b1b',
            900: '#7f1d1d',
            950: '#450a0a',
        },
        purple: {
            0: '#ffffff',
            50: '#faf5ff',
            100: '#f3e8ff',
            200: '#e9d5ff',
            300: '#d8b4fe',
            400: '#c084fc',
            500: '#a855f7',
            600: '#9333ea',
            700: '#7e22ce',
            800: '#6b21a8',
            900: '#581c87',
            950: '#3b0764',
        },
        lime: {
            50: '#f7fee7',
            100: '#ecfccb',
            200: '#d9f99d',
            300: '#bef264',
            400: '#a3e635',
            500: '#84cc16',
            600: '#65a30d',
            700: '#4d7c0f',
            800: '#3f6212',
            900: '#365314',
            950: '#1a2e05',
        }
    },
    semantic: {
        primary: {
            0: '{green.50}',
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '{gray.0}',
                    50: '{gray.50}',
                    100: '{gray.100}',
                    200: '{gray.200}',
                    300: '{gray.300}',
                    400: '{gray.400}',
                    500: '{gray.500}',
                    600: '{gray.600}',
                    700: '{gray.700}',
                    800: '{gray.800}',
                    900: '{gray.900}'
                },
                primary: {
                    color: '{green.200}',
                    contrastColor: '{green.700}',
                    hoverColor: '{green.300}',
                    activeColor: '{green.300}',
                },
                formField: {
                    borderColor: '{surface.400}',
                    disabledBackground: '{surface.100}',
                    focusBorderColor: '{surface.200}',
                },
                content: {
                    borderColor: '{surface.300}',
                },
                highlight: {
                    background: '{surface.50}',
                    focusBackground: '{surface.100}',
                    color: '{surface.600}',
                    focusColor: '{surface.600}', 
                }
            },
            dark: {
                surface: {
                    0: '{zinc.800}',
                    50: '{zinc.900}',
                    100: '{zinc.900}',
                    200: '{zinc.800}',
                    300: '{zinc.700}',
                    400: '{zinc.600}',
                    500: '{zinc.500}',
                    600: '{zinc.400}',
                    700: '{zinc.300}',
                    800: '{zinc.200}',
                    900: '{zinc.100}',
                },
                primary: {
                    color: '{green.200}',
                    contrastColor: '{green.700}',
                    hoverColor: '{green.300}',
                    activeColor: '{green.300}',
                },
                formField: {
                    borderColor: '{surface.400}',
                    disabledBackground: '{zinc.100}',
                    focusBorderColor: '{surface.500}',
                },
                content: {
                    borderColor: '{zinc.300}',
                },
                highlight: {
                    background: '{zinc.50}',
                    focusBackground: '{zinc.100}',
                    color: '{zinc.600}',
                    focusColor: '{zinc.600}', 
                }
            }
        }
    },
    components: {
        menubar: {
            background: '{surface.0}',
            item: {
                focus: {
                    background: '{surface.50}',
                    color: '{surface.900}',
                },
                active: {
                    background: '{surface.50}',
                    color: '{surface.900}',
                },
                border: {
                    radius: '0.5rem',
                },
            },
            submenu: {
                background: '{surface.0}',
                border: {
                    color: '{surface.300}',
                    radius: '0.9rem',
                },
                item: {
                    focus: {
                        background: '{surface.50}',
                    },
                }
            }
        },
        menu: {
            background: '{surface.0}',
            color: '{surface.900}',
            border: {
                color: '{surface.300}',
            },
            item: {
                color: '{surface.900}',
                focus: {
                    background: '{surface.50}',
                    color: '{surface.900}',
                },
            },
            submenu: {
                background: '{surface.0}',
                border: {
                    color: '{surface.300}',
                },
                item: {
                    focus: {
                        background: '{surface.50}',
                    }
                }
            }
        },
        button: {
            label: {
                font:  {
                    weight: 'medium',
                }
            },
            text: {
                secondary: {
                    color: '{surface.950}',
                    background: '{surface.50}',
                    hover: {
                        background: '{surface.100}!important',
                    },
                    active: {
                        background: '{surface.100}',
                    },
                    focus: {
                        background: '{surface.100}',
                    }
                },
                info: {
                    color: '{blue.600}',
                    background: '{blue.0}',
                    hover: {
                        background: 'transparent!important',
                        color: '{blue.400}!important',
                    },
                    active: {
                        background: '{blue.100}',
                    },
                    focus: {
                        background: '{blue.100}',
                    }
                },
            },
            success: {
                color: '{green.600}!important',
                background: '{green.200}!important',
                border: {
                    color: '{green.500}!important',
                },
                hover: {
                    background: '{green.300}!important',
                    color: '{green.700}!important',
                    border: {
                        color: '{green.600}!important',
                    },
                },
                focus: {
                    ring: {
                        color: '{green.200}',
                        shadow: '{green.200}',
                    }
                }
            },
            secondary: {
                color: '{surface.900}',
                background: '{surface.100}!important',
                border: {
                    color: '{surface.100}!important',
                },
                hover: {
                    background: '{surface.100}!important',
                    color: '{surface.900}!important',
                    border: {
                        color: '{surface.100}!important',
                    },
                },
                focus: {
                    ring: {
                        color: '{surface.200}',
                        shadow: '{surface.200}',
                    }
                }
            },
            info: {
                color: '{blue.0}!important',
                background: '{blue.500}!important',
                border: {
                    color: '{blue.500}!important',
                },
                hover: {
                    background: '{blue.600}!important',
                    color: '{blue.0}!important',
                    border: {
                        color: '{blue.600}!important',
                    },
                },
                focus: {
                    ring: {
                        color: '{blue.200}',
                        shadow: '{blue.200}',
                    }
                }
            },
            danger: {
                color: '{red.900}!important',
                background: '{red.400}!important',
                border: {
                    color: '{red.400}!important',
                },
                hover: {
                    background: '{red.600}!important',
                    color: '{red.900}!important',
                    border: {
                        color: '{red.600}!important',
                    },
                },
                focus: {
                    ring: {
                        color: '{red.500}',
                        shadow: '{red.500}',
                    }
                }
            },
        },
        skeleton: {
            background: '{surface.50}',
            animation: {
                background: '{surface.0}',
            }
        },
        toggleswitch: {
            background: '{surface.300}!important',
            hover: {
                background: '{surface.400}!important',
            },
            checked: {
                background: '{green.100}!important',
            },
            handle: {
                background: '{surface.0}!important',
                checked: {
                    background: '{surface.0}!important',
                    hover: {
                        background: '{surface.0}!important',
                    }
                },
                hover: {
                    background: '{surface.0}!important',
                }
            }
        },
        message: {
            warn: {
                color: '{yellow.600}!important',
                border: {
                    color: '{yellow.500}!important',
                },
                outlined: {
                    border: {
                        color: '{yellow.500}',
                    }
                },
                simple: {
                    color: '{yellow.500}!important',
                }
            },
            success: {
                color: '{green.400}!important',
                border: {
                    color: '{green.400}!important',
                },
                outlined: {
                    border: {
                        color: '{green.500}',
                    }
                },
                simple: {
                    color: '{green.500}',
                }
            }
        },
        inputtext: {
            background: '{surface.0}',
            color: '{surface.900}',
            disabled: {
                background: '{surface.100}',
            }
        },
        inputnumber: {
            background: '{surface.0}',
            color: '{surface.900}',
            disabled: {
                background: '{surface.100}',
            }
        },
        inputgroup: {
            addon: {
                background: '{surface.0}',
                border: {
                    color: '{surface.400}',
                }
            }
        },
        select: {
            background: '{surface.0}',
            color: '{surface.900}',
            overlay: {
                background: '{surface.0}',
                border: {
                    color: '{surface.300}',
                }
            },
            option: {
                color: '{surface.900}',
                focus: {
                    background: '{surface.50}',
                    color: '{surface.900}',
                },
                selected: {
                    background: '{surface.100}',
                    focus: {
                        background: '{surface.100}',
                        color: '{surface.900}',
                    },
                    color: '{surface.900}',
                }
            },
            disabled: {
                background: '{surface.100}',
            },
            lg: {
                padding: {
                    x: '1rem',
                    y: '0.5rem',
                }
            },
            transition: {
                duration: '1ms',
            }
        },
        dialog: {
            background: '{surface.0}',
            color: '{surface.900}',
            border: {
                color: '{surface.300}',
            }
        },
        avatar: {
            background: '{surface.100}!important',
            color: '{surface.900}',
            group: {
                border: {
                    color: '{surface.0}',
                }
            }
        },
        textarea: {
            background: '{surface.0}',
            color: '{surface.900}',
            border: {
                color: '{surface.300}',
            },
            filled: {
                background: '{surface.50}',
                color: '{surface.900}',
            },
            disabled: {
                background: '{surface.100}',
                color: '{surface.600}',
            }
        },
        accordion: {
            panel: {
                border: {
                    color: '{surface.300}',
                }
            },
            header: {
                background: '{surface.0}',
                color: '{surface.700}',
                border: {
                    color: '{surface.300}',
                },
                hover: {
                    background: '{surface.50}',
                    color: '{surface.900}',
                },
                active: {
                    background: '{surface.0}',
                    color: '{surface.800}',
                    hover: {
                        background: '{surface.0}',
                    }
                }
            },
            content: {
                background: '{surface.0}',
                color: '{surface.600}',
            }
        },
        progressbar: {
            background: '{surface.100}',
            value: {
                background: '{blue.500}',
            }
        },
        toast: {
            border: {
                radius: '1rem',
            }
        },
        fileupload:{
            background: '{surface.0}',
            border: {
                color: '{surface.200}',
            },
        },
        datatable: {
            border: {
                color: '{surface.100}',
            },
            header: {
                background: '{surface.0}',
                color: '{surface.800}',
                cell: {
                    background: '{surface.0}!important',
                    color: '{surface.800}!important',
                    border: {
                        color: '{surface.100}!important',
                    },
                },
                border: {
                    color: '{surface.100}',
                },
            },
            body: {
                background: '{surface.0}',
                color: '{surface.800}',
                cell: {
                    background: '{surface.0}!important',
                    color: '{surface.800}!important',
                    border: {
                        color: '{surface.100}',
                    },
                },
                border: {
                    color: '{surface.100}',
                },
            },
            row: {
                background: '{surface.0}',
                color: '{surface.900}',
            },
            footer: {
                background: '{surface.0}',
                color: '{surface.900}',
                border: {
                    color: '{surface.100}!important',
                },
                cell: {
                    background: '{surface.0}',
                    border: {
                        color: '{surface.100}!important',
                    },
                }
            },
        },
        paginator: {
            background: '{surface.0}',
            color: '{surface.900}',
            nav: {
                button: {
                    background: '{surface.0}',
                    color: '{surface.900}',
                    hover: {
                        background: '{surface.100}',
                    },
                    selected: {
                        background: '{surface.100}',
                    }
                }
            }
        },
        divider: {
            border: {
                color: '{surface.300}',
            },
            content: {
                background: '{surface.0}',
            }
        },
        card: {
            background: '{surface.0}',
            color: '{surface.900}',
            border: {
                color: '{surface.300}',
            }
        },
        tabs: {
            tab: {
                background: '{surface.0}',
                active: {
                    color: '{blue.500}',
                    border: {
                        color: '{blue.500}!important',
                    }
                }
            },
            tablist: {
                background: '{surface.0}',
            },
            tabpanel: {
                background: '{surface.0}',
                color: '{surface.900}',
            },
            active: {
                bar: {
                    background: '{blue.500}',
                    height: '2px',
                }
            }
        },
        toast: {
            border: {
                radius: '1rem',
            },
            info: {
                background: '{blue.50}',
                color: '{blue.400}!important',
                detail: {
                    color: '{surface.700}!important',
                }
            },
            success: {
                background: '{green.50}',
                color: '{green.400}!important',
                detail: {
                    color: '{surface.700}!important',
                }
            }
        },
        tooltip: {
            background: '{surface.100}',
            color: '{surface.900}',
        },
        tag: {
            font: {
                weight: 'medium',
            }
        },
        message: {
            secondary: {
                background: '{surface.100}!important',
                border: {
                    color: '{surface.200}!important',
                }
            },
        },
        selectbutton: {
            border: {
                radius: '10rem',
            }
        },
        togglebutton: {
            background: '{surface.100}!important',
            border: {
                radius: '10rem',
                color: '{surface.100}!important',
            },
            checked: {
                background: '{surface.100}!important',
                border: {
                    color: '{surface.100}!important',
                },
            },
            content: {
                checked: {
                    background: '{surface.0}!important',
                },
            },
            hover: {
                background: '{surface.100}!important',
                border: {
                    color: '{surface.100}!important',
                },
            }
        },
        progressbar: {
            label: {
                color: '{surface.0}',
            },
            background: '{surface.100}',
            value: {
                background: '{blue.400}',
            }
        }
    }
}

export default theme;